
// IMPORTS
import { mapActions } from 'vuex';
import { LOGIN, REFRESH, LOGOUT, LOGIN_OTP_REQUEST, LOGIN_OTP_VERIFY, FORGOT_PASSWORD_OTP_REQUEST, FORGOT_PASSWORD_OTP_VERIFY, RESET_PASSWORD_VERIFY } from '@/state/app/auth.state';

import { MEETING_ROOM_MODULE, GET_ALL_MEETING_ROOM } from '@/state/app/meetingRoom.state';

import { MEETING_ROOM_BOOKING_MODULE, GET_ALL_MEETING_ROOM_BOOKING, DELETE_MEETING_ROOM_BOOKING, SHOW_ALL_MEETING_ROOM_BOOKING, CREATE_MEETING_ROOM_BOOKING } from '@/state/app/meetingRoomBooking.state';

import { LOOKUP_MODULE, LOOKUP_MEETING_ROOM } from "@/state/app/lookup.state";

// EXPORTS
export const authMethods = mapActions('app/auth', [LOGIN, REFRESH, LOGOUT, LOGIN_OTP_REQUEST, LOGIN_OTP_VERIFY, FORGOT_PASSWORD_OTP_REQUEST, FORGOT_PASSWORD_OTP_VERIFY, RESET_PASSWORD_VERIFY]);

export const meetingRoomMethods = mapActions(MEETING_ROOM_MODULE, [GET_ALL_MEETING_ROOM]);

export const meetingRoomBookingMethods = mapActions(MEETING_ROOM_BOOKING_MODULE, [GET_ALL_MEETING_ROOM_BOOKING, DELETE_MEETING_ROOM_BOOKING, SHOW_ALL_MEETING_ROOM_BOOKING, CREATE_MEETING_ROOM_BOOKING]);


export const lookupMethods = mapActions(LOOKUP_MODULE, [LOOKUP_MEETING_ROOM]);
